import {
  Button,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
  Box,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { buy_nfts, cancel_nft_sell } from "../../keychain/login";
import { rutas } from "../../rutas/rutas";

export const Marketlace = () => {
  const { usuario, especiales = [], generalNft = [] } = useSelector((state) => state.userSlice);

  const [selector, setSelector] = useState(null);
  const [open2, setOpen2] = useState(false);
  const [cartas, setCartas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cargado, setCargado] = useState(false);
  const dispatch = useDispatch();

  // FILTROS
  const [search, setSearch] = useState("");
  const [rarezaFilter, setRarezaFilter] = useState("all");
  const [tipoFilter, setTipoFilter] = useState("all"); // all | especial | general
  const [simboloFilter, setSimboloFilter] = useState("all");
  const [sellerFilter, setSellerFilter] = useState("all"); // all | mine | others
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [sortBy, setSortBy] = useState("default");

  const handleClose2 = () => {
    setOpen2(false);
    setSelector(null);
  };

  const detectarTipoCarta = (cartaBase, especialesIdsSet) => {
    if (!cartaBase) return "general";
    if (especialesIdsSet.has(cartaBase.ide)) return "especial";
    return "general";
  };

  const handleTransform = (market = []) => {
    const deck = [...especiales, ...generalNft];
    const venidadPorJuego = [105];
    const especialesIdsSet = new Set(especiales.map((item) => item?.ide));

    if (deck.length === 0) {
      console.warn("Deck base vacío, no se pueden mapear los NFTs correctamente");
    }

    const deckprueba = market.reduce((acum, nft) => {
      const id = parseInt(nft?.grouping?.ID);
      if (!id) return acum;

      const cartaBase = deck.find((card) => card?.ide === id);
      if (!cartaBase) return acum;

      const tipoCarta = detectarTipoCarta(cartaBase, especialesIdsSet);
      const indexExistente = acum.findIndex((card) => card.ide === id);

      const nftInfo = {
        grupo: nft.grouping,
        nftId: nft.nftId,
        precio: Number(nft.price) || 0,
        simbolo: nft.priceSymbol || "",
        vendedor: nft.account || ""
      };

      if (indexExistente === -1) {
        return [
          ...acum,
          {
            ...cartaBase,
            tipoCarta,
            nft: [nftInfo]
          }
        ];
      } else {
        return acum.map((carta) =>
          carta.ide === id
            ? {
                ...carta,
                nft: [...carta.nft, nftInfo]
              }
            : carta
        );
      }
    }, []);

    return deckprueba.sort((a, b) =>
      venidadPorJuego.includes(a.ide) ? -1 : venidadPorJuego.includes(b.ide) ? 1 : 0
    );
  };

  const getCard = () => {
    setLoading(true);

    axios
      .post(`${rutas.smartContract}`, {
        jsonrpc: "2.0",
        id: 1,
        method: "find",
        params: {
          contract: "nftmarket",
          table: "NFTHUESOsellBook",
          query: {},
          limit: 1000,
          offset: 0,
          indexes: []
        }
      })
      .then((res) => {
        const deckSave = res?.data?.result || [];

        if (deckSave.length === 0) {
          console.warn("Respuesta vacía del market, reintentando en 3 segundos");
          setTimeout(getCard, 3000);
          return;
        }

        const transformed = handleTransform(deckSave);
        setCartas(transformed);
        setLoading(false);
        setCargado(true);
      })
      .catch((err) => {
        console.error("Error al obtener cartas del smart contract:", err);
        setCartas([]);
        setLoading(false);
      });
  };

  useEffect(() => {
    if ((especiales.length > 0 || generalNft.length > 0) && !cargado) {
      getCard();
    }
  }, [especiales, generalNft, cargado]);

  const simbolosDisponibles = useMemo(() => {
    const setSimbolos = new Set();

    cartas.forEach((carta) => {
      (carta?.nft || []).forEach((nft) => {
        if (nft?.simbolo) setSimbolos.add(nft.simbolo);
      });
    });

    return Array.from(setSimbolos);
  }, [cartas]);

  const cartasFiltradas = useMemo(() => {
    let resultado = [...cartas];

    resultado = resultado
      .map((carta) => {
        let nftFiltrados = [...(carta?.nft || [])];

        // filtro por símbolo
        if (simboloFilter !== "all") {
          nftFiltrados = nftFiltrados.filter((nft) => nft.simbolo === simboloFilter);
        }

        // filtro por vendedor
        if (sellerFilter === "mine") {
          nftFiltrados = nftFiltrados.filter((nft) => nft.vendedor === usuario?.user);
        } else if (sellerFilter === "others") {
          nftFiltrados = nftFiltrados.filter((nft) => nft.vendedor !== usuario?.user);
        }

        // filtro por precio mínimo
        if (minPrice !== "" && !isNaN(Number(minPrice))) {
          nftFiltrados = nftFiltrados.filter((nft) => Number(nft.precio) >= Number(minPrice));
        }

        // filtro por precio máximo
        if (maxPrice !== "" && !isNaN(Number(maxPrice))) {
          nftFiltrados = nftFiltrados.filter((nft) => Number(nft.precio) <= Number(maxPrice));
        }

        return {
          ...carta,
          nftFiltrados
        };
      })
      .filter((carta) => carta.nftFiltrados.length > 0);

    // búsqueda
    if (search.trim()) {
      const q = search.toLowerCase().trim();
      resultado = resultado.filter((carta) => {
        const nombre =
          carta?.nombre?.toLowerCase?.() ||
          carta?.name?.toLowerCase?.() ||
          carta?.titulo?.toLowerCase?.() ||
          "";
        const idTexto = String(carta?.id || "").toLowerCase();
        const ideTexto = String(carta?.ide || "").toLowerCase();

        return nombre.includes(q) || idTexto.includes(q) || ideTexto.includes(q);
      });
    }

    // filtro rareza
    if (rarezaFilter !== "all") {
      resultado = resultado.filter(
        (carta) => String(carta?.rareza || "").toLowerCase() === rarezaFilter.toLowerCase()
      );
    }

    // filtro tipo
    if (tipoFilter !== "all") {
      resultado = resultado.filter(
        (carta) => String(carta?.tipoCarta || "").toLowerCase() === tipoFilter.toLowerCase()
      );
    }

    // orden
    resultado.sort((a, b) => {
      const getNombre = (item) =>
        String(item?.nombre || item?.name || item?.titulo || "").toLowerCase();

      const precioMinA = Math.min(...(a?.nftFiltrados || []).map((x) => Number(x.precio) || 0));
      const precioMinB = Math.min(...(b?.nftFiltrados || []).map((x) => Number(x.precio) || 0));

      switch (sortBy) {
        case "name_asc":
          return getNombre(a).localeCompare(getNombre(b));
        case "name_desc":
          return getNombre(b).localeCompare(getNombre(a));
        case "id_asc":
          return Number(a?.ide || 0) - Number(b?.ide || 0);
        case "id_desc":
          return Number(b?.ide || 0) - Number(a?.ide || 0);
        case "price_asc":
          return precioMinA - precioMinB;
        case "price_desc":
          return precioMinB - precioMinA;
        default:
          return 0;
      }
    });

    return resultado;
  }, [
    cartas,
    search,
    rarezaFilter,
    tipoFilter,
    simboloFilter,
    sellerFilter,
    minPrice,
    maxPrice,
    sortBy,
    usuario?.user
  ]);

  const nftsDelSelector = useMemo(() => {
    if (!selector?.nft) return [];

    let lista = [...selector.nft];

    if (simboloFilter !== "all") {
      lista = lista.filter((nft) => nft.simbolo === simboloFilter);
    }

    if (sellerFilter === "mine") {
      lista = lista.filter((nft) => nft.vendedor === usuario?.user);
    } else if (sellerFilter === "others") {
      lista = lista.filter((nft) => nft.vendedor !== usuario?.user);
    }

    if (minPrice !== "" && !isNaN(Number(minPrice))) {
      lista = lista.filter((nft) => Number(nft.precio) >= Number(minPrice));
    }

    if (maxPrice !== "" && !isNaN(Number(maxPrice))) {
      lista = lista.filter((nft) => Number(nft.precio) <= Number(maxPrice));
    }

    return lista.sort((a, b) => Number(a.precio) - Number(b.precio));
  }, [selector, simboloFilter, sellerFilter, minPrice, maxPrice, usuario?.user]);

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        height: "100%",
        justifyContent: "center",
        overflow: "auto",
        p: { xs: 1, sm: 2 }
      }}
    >
      <Box sx={{ width: "100%" }}>
        {/* FILTROS */}
        <Box
          sx={{
            mb: 2,
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)"
            },
            gap: 1.5
          }}
        >
          <TextField
            label="Buscar carta"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            size="small"
            fullWidth
          />

          <FormControl size="small" fullWidth>
            <InputLabel>Rareza</InputLabel>
            <Select
              value={rarezaFilter}
              label="Rareza"
              onChange={(e) => setRarezaFilter(e.target.value)}
            >
              <MenuItem value="all">Todas</MenuItem>
              <MenuItem value="c">C</MenuItem>
              <MenuItem value="r">R</MenuItem>
              <MenuItem value="e">E</MenuItem>
              <MenuItem value="l">L</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Tipo</InputLabel>
            <Select
              value={tipoFilter}
              label="Tipo"
              onChange={(e) => setTipoFilter(e.target.value)}
            >
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="especial">Especial</MenuItem>
              <MenuItem value="general">General</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Símbolo</InputLabel>
            <Select
              value={simboloFilter}
              label="Símbolo"
              onChange={(e) => setSimboloFilter(e.target.value)}
            >
              <MenuItem value="all">Todos</MenuItem>
              {simbolosDisponibles.map((simbolo) => (
                <MenuItem key={simbolo} value={simbolo}>
                  {simbolo}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl size="small" fullWidth>
            <InputLabel>Vendedor</InputLabel>
            <Select
              value={sellerFilter}
              label="Vendedor"
              onChange={(e) => setSellerFilter(e.target.value)}
            >
              <MenuItem value="all">Todos</MenuItem>
              <MenuItem value="mine">Mis ventas</MenuItem>
              <MenuItem value="others">Otros usuarios</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Precio mínimo"
            type="number"
            size="small"
            fullWidth
            value={minPrice}
            onChange={(e) => setMinPrice(e.target.value)}
            inputProps={{ min: 0 }}
          />

          <TextField
            label="Precio máximo"
            type="number"
            size="small"
            fullWidth
            value={maxPrice}
            onChange={(e) => setMaxPrice(e.target.value)}
            inputProps={{ min: 0 }}
          />

          <FormControl size="small" fullWidth>
            <InputLabel>Ordenar</InputLabel>
            <Select
              value={sortBy}
              label="Ordenar"
              onChange={(e) => setSortBy(e.target.value)}
            >
              <MenuItem value="default">Por defecto</MenuItem>
              <MenuItem value="name_asc">Nombre A-Z</MenuItem>
              <MenuItem value="name_desc">Nombre Z-A</MenuItem>
              <MenuItem value="id_asc">ID menor a mayor</MenuItem>
              <MenuItem value="id_desc">ID mayor a menor</MenuItem>
              <MenuItem value="price_asc">Precio menor a mayor</MenuItem>
              <MenuItem value="price_desc">Precio mayor a menor</MenuItem>
            </Select>
          </FormControl>

          <Button
            variant="contained"
            onClick={() => {
              setSearch("");
              setRarezaFilter("all");
              setTipoFilter("all");
              setSimboloFilter("all");
              setSellerFilter("all");
              setMinPrice("");
              setMaxPrice("");
              setSortBy("default");
            }}
            fullWidth
          >
            Limpiar filtros
          </Button>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography sx={{ color: "white", fontWeight: "bold" }}>
            Resultados: {cartasFiltradas.length}
          </Typography>
        </Box>

        {loading ? (
          <Box sx={{ width: "100%", display: "flex", justifyContent: "center", mt: 4 }}>
            <CircularProgress color="inherit" />
          </Box>
        ) : (
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "repeat(2, 1fr)",
                sm: "repeat(3, 1fr)",
                md: "repeat(5, 1fr)",
                lg: "repeat(7, 1fr)",
                xl: "repeat(9, 1fr)"
              },
              gap: { xs: 1, sm: 1.5, md: 2 },
              alignItems: "start"
            }}
          >
            {cartasFiltradas.map((carta) => (
              <Box
                sx={{
                  width: "100%",
                  maxWidth: "130px",
                  mx: "auto",
                  position: "relative"
                }}
                key={`${carta.ide}-${carta.id}`}
              >
                <CardMedia
                  component="img"
                  image={carta?.url || ""}
                  alt="Carta"
                  sx={{
                    width: "100%",
                    height: { xs: "170px", sm: "180px", md: "190px" },
                    objectFit: "cover",
                    cursor: "pointer",
                    borderRadius: 1
                  }}
                  onClick={() => {
                    setSelector(carta);
                    setOpen2(true);
                  }}
                />

                <Typography
                  sx={{
                    background: carta?.id?.[0] === "E" ? "#2B21DE" : "#F50202",
                    position: "absolute",
                    top: 4,
                    left: 4,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    textAlign: "center",
                    color: "white",
                    fontSize: "13px",
                    lineHeight: "24px",
                    fontWeight: "bold"
                  }}
                >
                  {carta?.id?.[0] || "?"}
                </Typography>

                <Box
                  sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                    background: carta?.id?.[0] === "E" ? "#2B21DE" : "#F50202",
                    minWidth: "24px",
                    height: "24px",
                    px: 0.5,
                    borderRadius: "50%",
                    textAlign: "center",
                    color: "white",
                    fontSize: "13px",
                    lineHeight: "24px",
                    fontWeight: "bold"
                  }}
                >
                  {carta?.rareza?.toUpperCase() || "?"}
                </Box>

                <Box
                  sx={{
                    mt: 0.5,
                    textAlign: "center"
                  }}
                >
                  <Typography
                    sx={{
                      color: "white",
                      fontSize: { xs: "11px", sm: "12px" },
                      fontWeight: "bold",
                      lineHeight: 1.1
                    }}
                  >
                    {carta?.nombre || carta?.name || `ID ${carta?.ide}`}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#ddd",
                      fontSize: "11px"
                    }}
                  >
                    {carta?.nftFiltrados?.length || 0} venta(s)
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Box>

      {open2 && selector && (
        <Dialog open={open2} onClose={handleClose2} maxWidth="md" fullWidth>
          <DialogContent
            sx={{
              bgcolor: "background.paper",
              width: "100%",
              minHeight: { xs: "auto", md: "420px" },
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              p: 2
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                width: "100%",
                height: "100%",
                gap: 2
              }}
            >
              <Box sx={{ width: { xs: "100%", md: "40%" } }}>
                <CardMedia
                  component="img"
                  image={selector?.url || ""}
                  alt="Detalle Carta"
                  sx={{
                    width: "100%",
                    maxHeight: { xs: "320px", md: "100%" },
                    objectFit: "contain",
                    borderRadius: 1
                  }}
                />
              </Box>

              <Box
                sx={{
                  width: { xs: "100%", md: "60%" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between"
                }}
              >
                <Box sx={{ mb: 1 }}>
                  <Typography variant="h6" sx={{ color: "white", fontWeight: "bold" }}>
                    {selector?.nombre || selector?.name || `Carta ${selector?.ide}`}
                  </Typography>
                  <Typography sx={{ color: "#ccc", fontSize: "14px" }}>
                    ID: {selector?.ide} | Rareza: {selector?.rareza?.toUpperCase() || "?"} | Tipo:{" "}
                    {selector?.tipoCarta || "general"}
                  </Typography>
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    overflow: "auto",
                    border: "1px solid rgba(255,255,255,0.15)",
                    borderRadius: 1,
                    p: 1
                  }}
                >
                  {nftsDelSelector.length > 0 ? (
                    nftsDelSelector.map((nft) => (
                      <Box
                        key={nft.nftId}
                        sx={{
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          justifyContent: "space-between",
                          alignItems: { xs: "flex-start", sm: "center" },
                          gap: 1,
                          py: 1,
                          borderBottom: "1px solid gray"
                        }}
                      >
                        <Box>
                          <Typography sx={{ color: "white", fontWeight: "bold" }}>
                            Price: {parseFloat(nft.precio).toFixed(2)} {nft.simbolo}
                          </Typography>
                          <Typography sx={{ color: "#ccc", fontSize: "12px" }}>
                            Seller: {nft.vendedor}
                          </Typography>
                        </Box>

                        {usuario?.user !== nft.vendedor ? (
                          <Button
                            variant="contained"
                            onClick={() =>
                              buy_nfts(nft.nftId, nft.precio, nft.simbolo, "comprar")
                            }
                          >
                            Buy
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            onClick={() => cancel_nft_sell(nft.nftId)}
                          >
                            Cancel
                          </Button>
                        )}
                      </Box>
                    ))
                  ) : (
                    <Typography sx={{ color: "white" }}>
                      No hay NFTs disponibles con los filtros actuales.
                    </Typography>
                  )}
                </Box>

                <Button
                  sx={{ mt: 2 }}
                  fullWidth
                  variant="contained"
                  onClick={handleClose2}
                >
                  Close
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  );
};